"use client";

import { c as _c } from "react/compiler-runtime";
import type { EmblaOptionsType } from "embla-carousel";
import AutoScroll from "embla-carousel-auto-scroll";
import useEmblaCarousel from "embla-carousel-react";
import { cn } from "@/lib/utils";
import { AlgoliaIcon } from "@/ui/svg/algolia";
import { CloudinaryIcon } from "@/ui/svg/cloudinary";
import { DatadogIcon } from "@/ui/svg/datadog";
import { DockerIcon } from "@/ui/svg/docker";
import { NestjsIcon } from "@/ui/svg/nestjs";
import { NextjsIcon } from "@/ui/svg/nextjs";
import { NodejsIcon } from "@/ui/svg/nodejs";
import { PostgresIcon } from "@/ui/svg/postgres";
import { PrismaIcon } from "@/ui/svg/prisma";
import { ReactIcon } from "@/ui/svg/react";
import { SanityIcon } from "@/ui/svg/sanity";
import { TailwindIcon } from "@/ui/svg/tailwind";
import { TurborepoIcon } from "@/ui/svg/turborepo";
import { TypeScriptIcon } from "@/ui/svg/typescript";
import { V0Icon } from "@/ui/svg/v0";
import { VercelIcon } from "@/ui/svg/vercel";
import { WordPressIcon } from "@/ui/svg/wordpress";
import { WpGraphQLIcon } from "@/ui/svg/wpgraphql";
const proficiencies = [{
  name: "Next.js",
  icon: NextjsIcon
}, {
  name: "TypeScript",
  icon: TypeScriptIcon
}, {
  name: "React",
  icon: ReactIcon
}, {
  name: "Turborepo",
  icon: TurborepoIcon
}, {
  name: "Node.js",
  icon: NodejsIcon
}, {
  name: "Docker",
  icon: DockerIcon
}, {
  name: "Cloudinary",
  icon: CloudinaryIcon
}, {
  name: "Tailwind",
  icon: TailwindIcon
}, {
  name: "v0",
  icon: V0Icon
}, {
  name: "Vercel",
  icon: VercelIcon
}, {
  name: "Sanity",
  icon: SanityIcon
}, {
  name: "Postgres",
  icon: PostgresIcon
}, {
  name: "Algolia",
  icon: AlgoliaIcon
}, {
  name: "Nest.js",
  icon: NestjsIcon
}, {
  name: "WordPress",
  icon: WordPressIcon
}, {
  name: "WPGraphQL",
  icon: WpGraphQLIcon
}, {
  name: "Prisma",
  icon: PrismaIcon
}, {
  name: "Datadog",
  icon: DatadogIcon
}] as const;
export function ProficienciesCarousel() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      loop: true,
      align: "center",
      skipSnaps: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [AutoScroll({
      playOnInit: true,
      stopOnInteraction: false,
      startDelay: 0,
      speed: 1
    })];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [emblaRef] = useEmblaCarousel(t0 satisfies EmblaOptionsType, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="embla__container">{proficiencies.map(_temp)}</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== emblaRef) {
    t3 = <div className="w-full overflow-hidden"><div className="embla"><div className="embla__viewport" ref={emblaRef}>{t2}</div></div></div>;
    $[3] = emblaRef;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(item, index) {
  return <div key={index} className={cn("embla__slide", index === 0 ? "ml-0.5" : index === proficiencies.length - 1 ? "mr-0.5" : "")}><div className={cn("bg-muted/50 hover:bg-muted/70 flex h-full flex-col items-center justify-center rounded-lg p-5 text-center backdrop-blur-sm transition-colors", index === 0 ? "mr-2" : index === proficiencies.length - 1 ? "mr-3 ml-2" : "mx-2")}><item.icon /><span className="mt-2 text-xs font-medium sm:text-sm">{item.name}</span></div></div>;
}